import styled from 'styled-components';
import { greyText, black, white } from '../../styles/Variables';
import { IoIosArrowDown } from 'react-icons/io';
import { Link } from 'gatsby';

export const ArrowDownIcon = styled(IoIosArrowDown)`
    fill: ${greyText};
    font-size: 0.7em;

    &:hover {
        fill: ${black};
    }
`;

export const AccordionList = styled.ul`
    position: absolute;
    height: 0;
    overflow: hidden;
    transition: 0.25s;
    cursor: pointer;
    margin-top: 0.5em;
    color: ${greyText};
    background-color: ${white};
    font-size: 1em;
    list-style: none;
    padding: 0;
    padding-left: 1em;

    &:hover {
        color: ${black};
    }
`;

export const NavigationItems = styled.ul`
    padding: 1em;
    list-style: none;
    cursor: pointer;
    color: ${greyText};
    background-color: ${white};
    z-index: 3;
    font-weight: 200;
    font-size: 0.75em;

    &:hover ${AccordionList} {
        height: unset;
        width: 5em;
    }

    &:hover {
        color: ${black};
    }
`;

export const AccordionLanguage = styled.li`
    cursor: pointer;
    margin-top: 0.5em;
    color: ${greyText};
    background-color: ${white};
    font-family: Arial;
    font-size: 1em;

    &:hover {
        color: ${black};
    }
`;

export const AccordionTitle = styled.li`
    font-size: 12px;
    font-family: Arial;
    color: ${greyText};

    &:hover {
        color: ${black};
    }

    &:hover ${AccordionList} {
        height: 100px;
        width: 200%;
    }
`;

export const LanguageRedirect = styled(Link)`
    cursor: pointer;
    margin-top: 0.5em;
    color: ${greyText};
    background-color: ${white};
    font-family: Arial;
    font-size: 1em;

    &:hover {
        color: ${black};
    }
`;
